<template>
  <div class="content" style="height:100%;">
    <td >
<!--	    <img class :src="(examType === 'pre' || examType === '') && preCoverUrl ? preCoverUrl : (examType === 'beh' && behCoverUrl) ?  behCoverUrl : defaultCoverUrl" style="width:100%;display:block" />-->
		  <!-- <img class="" src="../../assets/images/logo.png" style="width: 23%;position: absolute;top: -12px;left: 11px;z-index: 2;"/> -->
		</td>
    <!-- <img class="banner" src="../../assets/images/banner.png" /> -->

    <div class="card">
      <div class="footer-top" style="height:35px;"></div>
      <img class="success" src="../../assets/images/success.png" />
      <div class="footer">{{ message }}</div>
    </div>
  </div>
</template>

<script>
import API from '@/api/common';
export default {
  name: "success",
  data() {
    return {
      openid: this.$route.query.openid,
      meetingId: this.$route.query.meetingId,
      examId: this.$route.query.examId,
      examType: this.$route.query.examType,
      department: this.$route.query.department,
      isSign: this.$route.query.isSign,
      answer: this.$route.query.answer,
      message: '',
      preCoverUrl: '',
      behCoverUrl: '',
      defaultCoverUrl: require('../../assets/images/top.jpg')
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.message = this.isSign == 1 ? '已签到，请勿重复提交' : '签到成功'
      this.getMeeting(this.meetingId)
      if (this.examId && this.answer == 0 && this.examId !='undefined' && this.examId != 'null') {
        this.message = '您已签到，请完成相关问卷'
        const openid = this.openid
        const meetingId = this.meetingId
        const examId = this.examId
        setTimeout(() => {
          this.$router.push({ 
            name: 'cityexam', 
            query: { openid: openid, meetingId: meetingId, examId: examId, examType: 'pre' }
          })
        }, 2000)
      }else if (this.examId && this.answer == 3 && this.examId !='undefined' && this.examId != 'null'){
        this.message = '签到成功，跳转问卷'
        const openid = this.openid
        const meetingId = this.meetingId
        const examId = this.examId
        setTimeout(() => {
          this.$router.push({
            name: 'cityexam',
            query: { openid: openid, meetingId: meetingId, examId: examId, examType: 'pre' }
          })
        }, 2000)
      }else if(this.answer == 1&& this.examId && this.examId !='undefined' && this.examId != 'null'){
        this.message = '已完成问卷，请勿重复提交'
      }
    },
    getMeeting(meetingId) {
      API.getMeeting(meetingId).then(result => {
        this.preCoverUrl = result.data.preCoverUrl
        this.behCoverUrl = result.data.behCoverUrl
        this.meetingName = result.data.tbTitle
      })
    }
  }
  
};
</script>

<style lang="less" scoped>
.content {
  background-color: #fff;
  .banner {
    width: 100%;
    height: auto;
  }

  .card {
    position: relative;
    // top: -175px;
    // width: 90%;
    margin-bottom: 30px;
    height: 60vh;
    margin: 0 auto;
    border-radius: 6px;

    .title {
      display: inline-block;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      width: 100%;
      margin: 20px auto;
    }

    .success {
      display: block;
      width: 50%;
      height: auto;
      margin: 40px auto;
    }

    .footer {
      font-size: 20px;
      font-weight: bold;
      text-align: center;
    }
  }
}
</style>
